import axios from 'axios';
import gql from 'graphql-tag';
import _ from 'lodash';
import Jimp from 'jimp';
import crypto from 'crypto';
import moment from 'moment';

export default {
  
  data() {
    return {
      // 远程同步要上传的图片
      remoteSyncImagesArr: [],
    };
  },
  
  methods: {
    // 远程同步
    async remoteAccessImages(type, val) {
      
      if (window.localStorage.getItem('system_set')) {
        const system_set = JSON.parse(window.localStorage.getItem('system_set'));
        if (system_set[type].ip && system_set[type].port && system_set[type].agentName) {
          let agentName = system_set[type].agentName;
          if (type === 'hairdressing') {
            if (this.commonData.patientId === -1) {
              this.$message.error("请添加患者信息");
              return;
            }
            if (this.commonData.relevantInfoId === -1) {
              this.$message.error("请添加相关信息");
              return;
            }
          } else {
            if (this.diagnosis_id === -1) {
              this.$message.error("请先添加检查部位!!!");
              return;
            }
          }
          /*if (val === 'sk1' || val === 'sk2') {
            this.skLoading = true;
          } else if (val === 'hairdressing') {
            this.uploading = true;
          } else {
            this[val + 'Loading'] = true;
          }*/
          try {
            // 获取http地址
            const url = `https://${system_set[type].ip}:${system_set[type].port}`;
            // 请求key并算出secret
            //const msgKey = await axios.get(url + '/key');
            // 设置 withCredentials: false， 否则会报跨域问题
            const msgKey = await axios.request({
              method: 'get',
              url: url + '/key',
              // added by zdh to unblock CROS
              withCredentials: false
            });

            const secret = crypto.createHash('sha1').update(msgKey.data.key.split('').reverse().join('')).digest('hex');
            /*// 获取保存在本地的lastsynctime
            let time = '';
            if (window.localStorage.getItem(`lastsynctime_${type}`)) {
              time = JSON.parse(window.localStorage.getItem(`lastsynctime_${type}`));
            }*/
            
            const getAgentSyncTimeRes = await this.$apollo.query({
              query: gql`{
										getAgentSyncTime(agent_name:"${agentName}")
								}`,
              fetchPolicy: "no-cache"
            });
  
            let agentSyncRes = getAgentSyncTimeRes.data.getAgentSyncTime;
  
            this.requestUrl = url + '/list?secret=' + secret + '&lastsynctime=' + agentSyncRes;
            this.url = url;
            this.secretPath = `?secret=${secret}`;
            // 请求list获取图片地址列表
            const msgList = await axios.request({
              method: 'get',
              url: this.requestUrl,
              // added by zdh to unblock CROS
              withCredentials: false
            });
            // 上传前清空列表
            this.remoteSyncImagesArr = [];
            if (msgList.data.agentname !== agentName) {
              this.$message.error('agentName不匹配！');
              return
            }
            await this.handleRemoteSyncImages(msgList.data, `${this.requestUrl}&path=`, '/');
            if (this.remoteSyncImagesArr.length === 0) {
              this.$message.error('没有找到可上传的图片');
              /*if (val === 'sk1' || val === 'sk2') {
                this.skLoading = false;
              } else if (val === 'hairdressing') {
                this.uploading = false;
              } else {
                this[val + 'Loading'] = false;
              }*/
              return
            }
            const newImagesArrAll = _.chunk(this.remoteSyncImagesArr, 1);
            
            if (newImagesArrAll && newImagesArrAll.length == 0){
              return
            }
            let syncLastTime = newImagesArrAll[newImagesArrAll.length-1][0].imgtime
            
            let count = 0;
            for (const imagesArr of newImagesArrAll) {
              // 上传前处理
              let imgArr = [];
              for (let i = 0; i < imagesArr.length; i++) {
                const item = imagesArr[i];
                const ext1 = item.file.match(/jpg$|jpeg$|png$/);
                let ext = ext1 ? ext1[0] : 'jpg';
                let b64 = await this.dealBmpImage2(item.url);
                if (!b64) {
                  b64 = await this.dealBmpImage2(item.url);
                }
                const obj = {};
                // 判断是不是美容模块
                if (type === 'hairdressing') {
                  obj.base64 = b64.replace(/^data:image\/(jpeg|png);base64,/, "");
                  obj.ext = ext;
                  obj.status = this.commonData.imageStatus === "无" ? "" : this.commonData.imageStatus;
                  obj.upload_mark = new Date().valueOf() + '_' + Math.floor(Math.random() * 1000);
                }
                imgArr.push(obj);
              }
              // 上传
              // 判断是不是美容
              const t = moment().valueOf();
              if (type === 'hairdressing') {
                // 显示正在上传缩略图
                this.showThumbnailImage(imgArr);
                await this.$apollo.mutate({
                  mutation: gql`mutation(
                    $patient_id: Int!
                    $treat_no: String!
                    $images: [cosmetologyImageInput!]!
                    $last_img_time: String
                    $agent_name: String
                  ){
                    addCosmetologyImages(
                      patient_id: $patient_id
                      treat_no: $treat_no
                      images: $images
                      last_img_time: $last_img_time
                      agent_name: $agent_name
                    )
                  }`,
                  variables: {
                    patient_id: this.commonData.patientId,
                    treat_no: this.commonData.treat_no,
                    images: imgArr,
                    last_img_time: syncLastTime,
                    agent_name: agentName
                  }
                });
              }
              count++;
              /*if (count === newImagesArrAll.length) {
                if (val === 'sk1' || val === 'sk2') {
                  this.skLoading = false;
                } else if (val === 'hairdressing') {
                  this.uploading = false;
                } else {
                  this[val + 'Loading'] = false;
                }
                this.$message({
                  message: "上传图片成功",
                  type: "success"
                });
              }*/
            }
          } catch (e) {
            this.$message.error('获取失败');
            /*if (val === 'sk1' || val === 'sk2') {
              this.skLoading = false;
            } else if (val === 'hairdressing') {
              this.uploading = false;
            } else {
              this[val + 'Loading'] = false;
            }*/
          }
        } else {
          this.$message.error('未获取到IP地址');
        }
      } else {
        this.$message.error('未获取到IP地址');
      }
    },
    // 取到远程同步要上传的图片
    async handleRemoteSyncImages(data, url, folderPath) {
      if (data.images.length) {
        for (const imageItem of data.images) {
          imageItem.name = decodeURIComponent(imageItem.file);
          imageItem.url = `${this.url}${folderPath}${imageItem.file}${this.secretPath}`;
          this.remoteSyncImagesArr.push(imageItem);
        }
      }
      if (data.folders.length) {
        for (const folderName of data.folders) {
          const response = await axios.request({
            method: 'get',
            url: `${url}${folderName}`
          });
          const folderUrl = folderPath !== '/' ? `${folderPath}` : '/';
          await this.handleRemoteSyncImages(response.data, `${url}${folderName}/`,`${folderUrl}${folderName}/`)
        }
      }
    },
    async dealBmpImage2(filePath) {
      try {
        const image = await Jimp.read(filePath);
        // image.quality(95);
        const base64 = await image.getBase64Async(Jimp.MIME_JPEG);
        if (base64) {
          return base64;
        } else {
          await this.dealBmpImage2(filePath);
        }
      } catch (e) {
        await this.dealBmpImage2(filePath)
      }
    
    },
  }
}
